import { render, staticRenderFns } from "./retailSet.vue?vue&type=template&id=5da662a6&scoped=true"
import script from "./retailSet.vue?vue&type=script&lang=js"
export * from "./retailSet.vue?vue&type=script&lang=js"
import style0 from "./retailSet.vue?vue&type=style&index=0&id=5da662a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da662a6",
  null
  
)

export default component.exports